<template>
	<section class="resource-section-row" v-if="rowId !== 0">
		<div class="b360-container-row">
			<h1>{{ Header }}</h1>
			<section :class="`description-row-content ${className}`">
				<p class="description">{{ Subheader }}</p>
				<router-link
					tag="button"
					:to="`/marketing-resources/${className}`"
					:class="`view-all-btn ${className}`"
					v-if="rowId !== 0"
					>View All</router-link
				>
			</section>
		</div>
		<section class="resource-content-row">
			<!-- <swiper :options="swiperOption">
				<article v-for="item in content" class="swiper-slide" :key="item.id">
					<ResourceCard :item="item" :className="`swiper-row-${rowId}`" />
				</article>
				<ViewAllCard
					v-if="rowId !== 0"
					:linkLocation="`/marketing-resources/${className}`"
				/>
			</swiper> -->

			<!-- <div :class="`swiper-row-${rowId}-prev`" class="swiper-button-prev">
				<font-awesome-icon :icon="['fas', 'chevron-left']" />
			</div>
			<div :class="`swiper-row-${rowId}-next`" class="swiper-button-next">
				<font-awesome-icon :icon="['fas', 'chevron-right']" />
			</div> -->
		</section>
	</section>
</template>

<script>
import ResourceCard from '@/components/cards/ResourceCard.vue';
import ViewAllCard from '@/components/cards/ViewAllCard.vue';
// import 'swiper/dist/css/swiper.css';

import {
	faChevronLeft,
	faChevronRight,
	faEye,
} from '@fortawesome/pro-solid-svg-icons/';
import { library } from '@fortawesome/fontawesome-svg-core';
// import { swiper } from 'vue-awesome-swiper';

library.add(faChevronLeft, faChevronRight, faEye);

export default {
	name: 'ResourceSectionRow',
	components: {
		// swiper,
		ResourceCard,
		ViewAllCard,
	},
	props: {
		rowId: Number,
		Header: String,
		Subheader: String,
		content: Array,
		className: String,
	},
	data() {
		return {
			// inSwiper: 'swiper-slide',
			// swiperOption: {
			// 	slidesPerView: 'auto',
			// 	centeredSlides: false,
			// 	freeMode: true,
			// 	navigation: {
			// 		// TODO : take in param to make classes unique with dynamic binding
			// 		nextEl: `.swiper-row-${this.rowId}-next`,
			// 		prevEl: `.swiper-row-${this.rowId}-prev`,
			// 	},
			// 	on: {
			// 		init() {
			// 			// start hide previous button
			// 			const sliderPrevBtns =
			// 				document.getElementsByClassName('swiper-button-prev');
			// 			for (let i = 0; i < sliderPrevBtns.length; i += 1) {
			// 				sliderPrevBtns[i].classList.add('hidden');
			// 			}
			// 		},
			// 		slideNextTransitionStart() {
			// 			// show previous button
			// 			const prevParent = this.el.parentNode;
			// 			prevParent
			// 				.querySelector('.swiper-button-prev')
			// 				.classList.remove('hidden');
			// 		},
			// 	},
			// 	breakpoints: {
			// 		480: {
			// 			freeMode: true,
			// 		},
			// 	},
			// },
		};
	},
	created() {},
	filters: {
		truncate(content, contentType) {
			if (!content) return '';
			const value = content.toString();
			if (contentType === 'video') {
				return `${value.substring(0, 82)}...`;
			}
			if (contentType === 'document') {
				return `${value.substring(0, 18)}...`;
			}
			//  TODO : IS THIS ALL VALUES?
			return value;
		},
		lowerCase(content) {
			return content || content === 0
				? content.toString().toLowerCase().trim()
				: '';
		},
	},
};
</script>

<style lang="scss" scoped>
section.resource-section-row {
	border-bottom: 1px solid $border-color-light;
	position: relative;
	display: flex;
	flex-direction: column;
	webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	h1 {
		margin-bottom: unset;
	}

	.description-row-content {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		@include rem(margin-bottom, 30px);

		p.description {
			margin: unset;
			@include rem(font-size, 15px);
		}

		button.view-all-btn {
			padding: 12px 15px;
			background-color: $white;
			border: 1px solid $border-color-light;
			border-radius: $b360-border-radius-base;
			color: $brand-blue;
			font-family: 'Roboto Medium';
			@include rem(font-size, 15px);
			cursor: pointer;
			z-index: 2;
			@include typo--roboto__medium;
			@include mobile {
				display: none;
			}
		}
	}

	&:last-child {
		border-bottom: unset;
	}
}

/* .swiper-container {
	margin-top: -50px;
	padding-top: 50px;
	margin-bottom: -50px;
	padding-bottom: 50px;
} */

.resource-content-row {
	display: flex;

	/* .swiper-wrapper {
		article {
			&:first-child {
				@include sm {
					margin-left: 15px;
				}
			}
		}
	} */

	article {
		/* &.swiper-slide {
			margin-right: unset;
			transform: scale(1);
			height: 100%;
			position: relative;
			box-sizing: border-box;
			@include rem(margin-left, 30px);
			width: unset;
			border: 2px solid transparent;
			transition: all $b360-motion-duration--long
				$b360-motion-easing--accelerate;

			&:not(:last-child):hover {
				transform: scale(1.05);
			}

			@include mobile {
				margin-left: unset;
				@include rem(margin-right, 25px);
			}

			[data-article-type='Video'],
			[data-article-type='Video'] .card-wrapper {
				@include mobile {
					width: 300px;
				}

				@include mobile-min {
					width: 270px;
				}
			}
		} */

		[data-article-type='document'],
		[data-article-type='document'] .card-wrapper {
			width: 140px;

			figure {
				margin: unset;
				height: 100%;
			}
		}

		[data-article-type='video'] .card-wrapper {
			display: flex;
			justify-content: center;
		}

		[data-article-type='viewall'] .card-wrapper {
			display: flex;
			justify-content: center;
			width: 140px;
			border: 1px solid $border-color-light;
			color: $brand-blue;

			svg {
				font-size: 48px;
				color: $brand-blue;
			}

			a {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				text-decoration: none;
				background-color: transparent;
				transition: $b360-motion-fade--in;

				&:hover {
					background-color: $border-color-light;
				}

				figure {
					display: flex;
					flex-wrap: wrap;

					.view-all-text {
						text-decoration: none;
						color: $brand-blue;
					}
				}
			}
		}

		.card-wrapper {
			position: relative;
			height: 200px;
			border-radius: $b360-border-radius-base;

			img,
			.card-link {
				width: 100%;
				height: 100%;
				cursor: pointer;
				border-radius: $border-radius;
				object-fit: cover;
			}

			.notification {
				@include rem(padding, 5px);
				border-radius: $b360-border-radius-base;
				position: absolute;
				bottom: 11px;
				left: 11px;

				&.new {
					color: $white;
					@include typo--roboto__bold;
					@include rem(font-size, 12px);
					@include rem(line-height, 12px);
				}
			}
		}

		h2 {
			@include rem(font-size, 17px);
			@include typo--roboto__medium;
			@include rem(line-height, 17px);
			@include rem(margin, 20px 0 10px 0);
			text-transform: capitalize;
		}

		p {
			@include rem(font-size, 15px);
			@include typo--roboto__regular;
			color: $b360-color--gray__darkest;
			padding: 0 0 10px 0;
		}

		.learn-more {
			color: $brand-blue;
			text-decoration: none;
			@include typo--roboto__medium;

			&:hover,
			&:focus {
				text-decoration: underline;
			}
		}
	}

	/* .swiper-button-prev,
	.swiper-button-next {
		position: absolute;
		top: 50%;
		width: 44px;
		height: 44px;
		z-index: 8;
		@include flex-center;
		@include rem(font-size, 22px);
		line-height: 40px;
		color: $brand-blue;
		cursor: pointer;
		background-image: none;
		background-color: $white;
		-moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
		border-radius: $b360-border-radius-base;

		&[aria-disabled='true'] {
			display: none;
		}

		@include mobile {
			display: none;
		}
	}

	.swiper-button-next,
	.swiper-container-rtl .swiper-button-prev {
		right: 15px;
		left: auto;
	}

	.swiper-button-prev,
	.swiper-container-rtl .swiper-button-next {
		left: 15px;
		right: auto;
	} */
}
</style>
